var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('ecommerce-revenue-report',{attrs:{"data":_vm.data.deviceInfo,"hatchery_device_id":_vm.hatchery_device_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }